import React from 'react';
import './index.scss';

const ErrorSection = ({ title, subtitle }) => {
  return (
    <div className={'error_section_container'}>
      <div className={'title'}>{title}</div>
      <div className={'subtitle'}>{subtitle}</div>
    </div>
  );
};

export default ErrorSection;
